@if (card && card.loading !== true) {
  @if (!card.templateLost) {
    <div class="card mat-elevation-z2" [attr.data-testid]="'message-card'">
      @if (customize('image'); as image) {
        <div
          class="header"
          [style.background-image]="'url(' + (image | imageType) + ')'"
          [style.height]="card.layout === 'share-add-friend' ? '268px' : ''"
          [attr.data-testid]="'message-card-header'"
        ></div>
      }
      @if (card.layout !== 'share-add-friend') {
        <div class="container" [attr.data-testid]="'message-card-container'">
          <div class="title" [attr.data-testid]="'message-card-title'">
            {{ customize('title') | length: 20 }}
          </div>
          <div
            class="content"
            [innerHTML]="customize('content') | nl2br | length: 60"
            [attr.data-testid]="'message-card-content'"
          ></div>
        </div>
      }
      @if (card.layout === 'share-add-friend') {
        <div class="flex">
          <div
            class="button w-1/2 p-1 border-r border-gray-300 border-solid"
            [class.active]="card.buttons[0].isSelected"
            [style.background-color]="
              card.buttons[0]['backgroundColor'] || '#000000'
            "
            [style.color]="card.buttons[0]['color'] || '#ffffff'"
          >
            {{ card.buttons[0]['label'] }}
          </div>
          <div
            class="button w-1/2 p-1"
            [class.active]="card.buttons[1].isSelected"
            [style.background-color]="
              card.buttons[1]['backgroundColor'] || '#000000'
            "
            [style.color]="card.buttons[1]['color'] || '#ffffff'"
          >
            {{ card.buttons[1].label }}
          </div>
        </div>
      } @else {
        <div class="buttons" [attr.data-testid]="'message-card-buttons'">
          @for (index of buttonIndexes; track index) {
            @if (customizeButton(index); as button) {
              <div
                class="button"
                [class.active]="button.isSelected"
                [matTooltip]="tooltip"
                [attr.data-testid]="'message-card-button-' + index"
              >
                <div class="flex justify-center items-center relative">
                  {{ button.label }}
                  @if (hasShareAction(button)) {
                    <ms-share-preview
                      [messageId]="button['messageId']"
                      [shareCurrentMessage]="button['shareCurrentMessage']"
                      [package]="package"
                      class="absolute right-0"
                    ></ms-share-preview>
                  }
                </div>
                <ng-template #tooltip>
                  @switch (button.type) {
                    @case ('postback') {
                      {{ button.type | buttonType }}
                    }
                    @case ('message') {
                      {{ button.type | buttonType }} : {{ button['text'] }}
                    }
                    @case ('uri') {
                      {{ button.type | buttonType }} : {{ button['uri'] }}
                    }
                    @case ('next') {
                      {{ button.type | buttonType }}
                    }
                    @case ('share-message') {
                      {{ button.type | buttonType }} :
                      {{ button['shareMessageName'] }}
                    }
                    @case ('add-friend') {
                      {{ button.type | buttonType }}
                    }
                    @case ('share-add-friend') {
                      {{ button.type | buttonType }} :
                      {{ button['shareMessageName'] }}
                    }
                    @default {}
                  }
                </ng-template>
              </div>
            }
          }
        </div>
      }
    </div>
  } @else {
    <div
      class="card mat-elevation-z2 template-lost"
      i18n
      [attr.data-testid]="'message-card-template-lost'"
    >
      <mat-icon class="mat-18">search_off</mat-icon><br />
      圖像編輯器中的卡片已被刪除<br />無法預覽
    </div>
  }
} @else {
  <gosu-loading i18n [attr.data-testid]="'message-card-loading'"
    >卡片繪製中請稍候</gosu-loading
  >
}
